
ADILF.define('adilf/apps/social/promo-modules/social-media/app',['require','exports','module','streamhub-sdk/jquery','adilf/handler','adilf/context','adilf/util/utils','adilf/util/config-validator','streamhub-sdk/collection','adilf/apps/social/promo-modules/collection-promo-base/views/content-view-factory','adilf/apps/social/promo-modules/collection-promo-base/views/twitter-content-view','adilf/apps/social/promo-modules/social-media/views/list-view'],function (require, exports, module) {/* App: Social */
"use strict";

var jquery = require('streamhub-sdk/jquery');
var Handler = require('adilf/handler');
var Context = require('adilf/context');
var utils = require('adilf/util/utils');
var ConfigValidator = require('adilf/util/config-validator');
var Collection = require('streamhub-sdk/collection');
var ContentViewFactory = require('adilf/apps/social/promo-modules/collection-promo-base/views/content-view-factory');
var TwitterContentView = require('adilf/apps/social/promo-modules/collection-promo-base/views/twitter-content-view');
var SocialMediaPromoListView = require('adilf/apps/social/promo-modules/social-media/views/list-view');

var SocialMediaPromo = function(conf) {
    conf = conf || {};
    this.conf = conf;

    this.selectors = {
        'promo_module': 'adi-smm',
        'promo_module_content': 'adi-ssm-content', // OOPS, 'ssm' is a typo that will live on forever because CSS uses it
        'river_item': '.river-item'
    };

    if(!ConfigValidator.call(this, {
        app: 'SocialMediaPromo',
        defaultEl: this.selectors.promo_module,
        required: ['articleId', 'siteId', 'network', 'environment', 'timeout']
    })) return;

    this.gaHandler = this.conf.gaHandler;
    if(this.gaHandler) {
        this.gaHandler.registerEvent({
            scope: '#news-river',
            eventName: 'click',
            selector: '#adi-smm .hub-content-action-reply',
            gaEventName: 'twitter_reply_click'
        });
        this.gaHandler.registerEvent({
            scope: '#news-river',
            eventName: 'click',
            selector: '#adi-smm .hub-content-action-retweet',
            gaEventName: 'twitter_retweet_click'
        });
        this.gaHandler.registerEvent({
            scope: '#news-river',
            eventName: 'click',
            selector: '#adi-smm .hub-content-action-favorite',
            gaEventName: 'twitter_favorite_click'
        });
        this.gaHandler.registerEvent({
            scope: '#news-river',
            eventName: 'click',
            selector: '#adi-smm .content-author-name, #adi-smm .content-author-username, #adi-smm .content-author-avatar',
            gaEventName: 'twitter_author_click'
        });
        this.gaHandler.registerEvent({
            scope: '#news-river',
            eventName: 'click',
            selector: '#adi-smm .content-created-at',
            gaEventName: 'twitter_timestamp_click'
        });
        this.gaHandler.registerEvent({
            scope: '#news-river',
            eventName: 'click',
            selector: '#adi-smm .content-attachment-link a, #adi-smm .content-attachment-rich a',
            gaEventName: 'twitter_link-attachment_click'
        });

        this.gaHandler.registerEvent({
            scope: '#news-river',
            eventName: 'click',
            selector: '#adi-smm .content-attachment',
            gaEventName: function(e) {
                var $el = jquery(e.currentTarget),
                    eventName;
                if($el.find('.content-attachment-controls-play').length) {
                    eventName = 'twitter_video-attachment_click';
                } else if($el.find('.content-attachment-photo').length) {
                    eventName = 'twitter_photo-attachment_click';
                }
                return eventName;
            }
        });
        this.gaHandler.registerEvent({
            scope: '#news-river',
            eventName: 'click',
            selector: '#adi-smm .content-body-main a',
            gaEventName: function(e) {
                var $el = jquery(e.currentTarget);
                var eventName = 'twitter_link_click';
                if($el.hasClass('fyre-hashtag')) {
                    eventName = 'twitter_hashtag_click';
                }
                if($el.hasClass('fyre-mention-twitter')) {
                    eventName = 'twitter_at-mention_click';
                }
                return eventName;
            }
        });
    }

    Handler.apps[this.conf.name] = this;
    if(this.conf.autoStart) { this.init(); }
};

SocialMediaPromo.prototype.init = function() {

    this._setupDOM();

    this.collection = new Collection({
        network: this.conf.network,
        siteId: this.conf.siteId,
        articleId: this.conf.articleId,
        environment: this.conf.environment
    });

    this.collectionPromo = new SocialMediaPromoListView({
        el: document.getElementById(this.selectors.promo_module_content),
        initial: 1,
        timeout: this.conf.timeout,
        slug: this.conf.slug,
        theme: this.conf.theme,
        contentViewFactory: new ContentViewFactory({
            defaultContentView: TwitterContentView
        })
    });

    this.collectionPromo.on('killPromo.adi', function(e) {
        Handler.removeApp(this.conf.name);
        if(this.gaHandler) {
            this.gaHandler.track('twitter_close_click');
        }
    }.bind(this));

    if(this.gaHandler) {
        this.collectionPromo.on('rendered.adi', function(e) {
            this.gaHandler.track('twitter_visible');
        }.bind(this));
    }

    this.collection.pipe(this.collectionPromo);
};

SocialMediaPromo.prototype.destroy = function() {
    this.collectionPromo.destroy();
};

SocialMediaPromo.prototype._setupDOM = function() {
    var $anchor = jquery('#'+this.selectors.promo_module);
    this.conf.$el = jquery('<div id="'+this.selectors.promo_module_content+'"></div>');
    $anchor.detach();
    $anchor.append(this.conf.$el);
    jquery(jquery(this.selectors.river_item)[0]).before($anchor);
};

module.exports = SocialMediaPromo;
});
